import React from "react";
import '../styles/questionAdhd.css';

function QuestionAdhd({ question, category, index, onAnswer }) {
    const handleChange = (event) => {
        const points = parseInt(event.target.value, 10);
        onAnswer(category, points, index);
    };
    const options = ["Aldrig", "Sällan", "Ibland", "Ofta", "Mycket ofta"];

return (
    <div className="question">
        <p>{question}</p>
        <div className="radio-container">
            {options.map((option, index) => {
                // Create a unique ID by combining the category, question text, and index
                const id = `${category}-${question.replace(/\s+/g, "-")}-${index}`;
                return (
                    <div key={id} className="radio-option">
                        <input
                            type="radio"
                            id={id}
                            name={question}
                            value={index}
                            className="radio-input"
                            onChange={handleChange}
                        />
                        <label htmlFor={id} className="radio-label">
                            {option}
                        </label>
                    </div>
                );
            })}
        </div>
    </div>
);
};

export default QuestionAdhd;